import { createFileRoute } from '@tanstack/react-router';
import UserSubscriptionDetailPage from '@/features/subscription/user-subscription-detail-page';
import {
  subscriptionDetailParamsSchema,
  subscriptionDetailSearchSchema,
} from '@/features/subscription/shared/subscription-detail.schema';

export const Route = createFileRoute('/users/$userId/subscription/$subscriptionId')({
  params: {
    parse: (raw) => subscriptionDetailParamsSchema.parse(raw),
    stringify: ({ userId, subscriptionId }) => ({
      userId: String(userId),
      subscriptionId: String(subscriptionId),
    }),
  },
  validateSearch: subscriptionDetailSearchSchema,
  loader: async ({ context, params }) => {
    void context;
    void params;
  },
  component: UserSubscriptionDetailPage,
});
